module.exports = {"430721100":"深柳镇","430721101":"大鲸港镇","430721102":"黄山头镇","430721103":"三岔河镇","430721104":"官垱镇","430721105":"下渔口镇","430721106":"陈家嘴镇","430721108":"大湖口镇","430721201":"安障乡","430721205":"安全乡","430721208":"安丰乡","430721210":"安康乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430721.json
// module id = 1997
// module chunks = 0